(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-pdp-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.hb-pdp-reels');
    sections.forEach((section) => {
      const viewport = section.querySelector('[data-reels-viewport]');
      const prev = section.querySelector('[data-reels-prev]');
      const next = section.querySelector('[data-reels-next]');
      if (!viewport || !prev || !next) return;

      const getStep = () => {
        const card = section.querySelector('.hb-pdp-reels__card');
        if (!card) return 260;
        const styles = window.getComputedStyle(section.querySelector('.hb-pdp-reels__track'));
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };

      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pdpSections = document.querySelectorAll('.hb-pdp');

    pdpSections.forEach((section) => {
      const mainImage = section.querySelector('.hb-pdp__image');
      const thumbs = Array.from(section.querySelectorAll('.hb-pdp__thumb[data-full-src]'));

      if (!(mainImage instanceof HTMLImageElement) || thumbs.length === 0) return;

      let activeIndex = Math.max(
        0,
        thumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
      );

      const setActiveThumb = (nextIndex) => {
        const normalizedIndex = (nextIndex + thumbs.length) % thumbs.length;
        const nextThumb = thumbs[normalizedIndex];
        if (!(nextThumb instanceof HTMLElement)) return;

        activeIndex = normalizedIndex;

        const fullSrc = nextThumb.dataset.fullSrc;
        if (fullSrc) {
          mainImage.src = fullSrc;
          mainImage.srcset = '';
          mainImage.sizes = '';
        }

        if (nextThumb.dataset.alt) {
          mainImage.alt = nextThumb.dataset.alt;
        }

        thumbs.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === normalizedIndex);
          thumb.setAttribute('aria-current', index === normalizedIndex ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          setActiveThumb(index);
        });
      });

      let startX = 0;
      let startY = 0;
      mainImage.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        startY = event.clientY;
      });

      mainImage.addEventListener('pointerup', (event) => {
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) {
          setActiveThumb(activeIndex + 1);
        } else {
          setActiveThumb(activeIndex - 1);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActiveThumb(activeIndex + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActiveThumb(activeIndex - 1);
        }
      });
    });

    const forms = document.querySelectorAll('.hb-pdp__form');

    forms.forEach((form) => {
      if (form.dataset.hbCartBound === 'true') return;
      form.dataset.hbCartBound = 'true';

      form.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        if (!(submitter instanceof HTMLElement)) return;

        // Only intercept "Add to cart". Keep "Buy now" native checkout flow.
        if (!submitter.classList.contains('hb-pdp__add')) return;

        event.preventDefault();

        const variantInput = form.querySelector('input[name="id"]');
        if (!(variantInput instanceof HTMLInputElement) || !variantInput.value) return;

        const quantityInput = form.querySelector('input[name="quantity"]');
        const quantity = Math.max(1, Number(quantityInput?.value || 1));

        const buttons = form.querySelectorAll('button');
        buttons.forEach((button) => {
          button.disabled = true;
        });

        try {
          if (window.Shopify?.actions?.updateCart && window.Shopify?.actions?.openCart) {
            await window.Shopify.actions.updateCart({
              lines: [{ merchandiseId: variantInput.value, quantity }],
            });
            await window.Shopify.actions.openCart();
          } else {
            const body = new FormData();
            body.set('id', variantInput.value);
            body.set('quantity', String(quantity));

            await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              body,
            });

            const drawer = document.querySelector('theme-drawer#cart-drawer');
            if (drawer?.open) {
              drawer.open();
            } else {
              window.location.href = window.Theme?.routes?.cart_url || '/cart';
            }
          }
        } catch (error) {
          console.error('[hb-product-main] add to cart failed', error);
          form.submit();
        } finally {
          buttons.forEach((button) => {
            button.disabled = false;
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-hb-showcase]');

    carousels.forEach((carousel) => {
      const cards = Array.from(carousel.querySelectorAll('.hb-showcase__card'));
      const dots = Array.from(carousel.querySelectorAll('.hb-showcase__dot'));
      const prevBtn = carousel.querySelector('.hb-showcase__arrow--prev');
      const nextBtn = carousel.querySelector('.hb-showcase__arrow--next');
      const total = cards.length;

      if (!total) return;

      let index = 0;
      let startX = 0;
      let startY = 0;

      const update = () => {
        cards.forEach((card, cardIndex) => {
          card.classList.remove('is-primary', 'is-secondary', 'is-tertiary', 'is-hidden');
          const relative = (cardIndex - index + total) % total;
          if (relative === 0) card.classList.add('is-primary');
          else if (relative === 1) card.classList.add('is-secondary');
          else if (relative === 2) card.classList.add('is-tertiary');
          else card.classList.add('is-hidden');
        });

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      const goNext = () => {
        index = (index + 1) % total;
        update();
      };

      const goPrev = () => {
        index = (index - 1 + total) % total;
        update();
      };

      prevBtn?.addEventListener('click', goPrev);
      nextBtn?.addEventListener('click', goNext);

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          index = dotIndex;
          update();
        });
      });

      carousel.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        startY = event.clientY;
      });

      carousel.addEventListener('pointerup', (event) => {
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) goNext();
        else goPrev();
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
